import dashboardRoute from './dashboard-route'

export default () => [
  dashboardRoute(),
]
